import { createActionWithPayload, IActionWithPayload } from '../utils';

const ACTION_SIDE_MENU_EXPANDED = 'UI/SIDE_MENU_EXPANDED';

export interface UIDataState {
  sideMenuExpanded?: boolean;
}

const initialState: UIDataState = {
  sideMenuExpanded: false,
};

type SideMenuExpandedActionTyoe = IActionWithPayload<
  typeof ACTION_SIDE_MENU_EXPANDED,
  boolean
>;

type Actions = SideMenuExpandedActionTyoe;

export const sideMenuExpandedAction = (
  expanded: boolean
): SideMenuExpandedActionTyoe => {
  return createActionWithPayload(ACTION_SIDE_MENU_EXPANDED, expanded);
};

// reducer
export const uiDataReducer = (
  state: UIDataState = initialState,
  action: Actions
): UIDataState => {
  switch (action.type) {
    case ACTION_SIDE_MENU_EXPANDED:
      return {
        ...state,
        sideMenuExpanded: action.payload,
      };
    default:
      return state;
  }
};
